<template>
  <div class="card__container" @mousedown="markStartCursor" @mouseup="redirectToSlug(info.slug, $event)">
    <template v-if="badge.text">
      <div class="card__badge" :style="setBadgeStyle(badge.bgColor, badge.textColor)">
        <div :style="innerBadgeStyle(badge.bgColor)">
          {{ badge.text }}
        </div>
      </div>
    </template>
    <div v-if="info.desktopCardAsset" class="card__image-wrapper">
      <img
        class="card__image"
        :src="info.desktopCardAsset"
        :alt="info.publicTitle"
        :loading="loadImageLazily ? 'lazy' : false"
      />
    </div>
    <div v-else class="card__image-wrapper card__image-wrapper--placeholder" />
    <ul class="card__labels">
      <li v-for="(keyword, index) in info.keywords" :key="index">{{ keyword }}</li>
    </ul>
    <div class="card__text">
      <strong class="card__title">{{ info.publicTitle }}</strong>
      <p class="card__content">{{ info.publicDescription }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'course-card',
  props: {
    info: {
      type: Object,
    },
    loadImageLazily: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      startCursor: { x: 0, y: 0 },
    };
  },
  computed: {
    badge() {
      return this.info.cardInfo || { text: null, textColor: '#ffffff', bgColor: '#ff7450' };
    },
  },
  methods: {
    setBadgeStyle(bgColor, textColor) {
      return {
        backgroundColor: bgColor,
        color: textColor,
      };
    },
    innerBadgeStyle(bgcolor) {
      return {
        backgroundImage: `linear-gradient(90deg, rgba(255, 255, 255, 0.3) 0%, ${bgcolor}`,
      };
    },
    redirectToSlug(slug, event) {
      const { x, y } = this.startCursor;
      if (event.x !== x || event.y !== y) return;
      if (this.info?.useNewTab === false) window.location.href = `${slug}`;
      else window.open(`/${slug}`);
    },
    markStartCursor(event) {
      this.startCursor = {
        x: event.x,
        y: event.y,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../scss/utils/mixin';
@import './icon/course-card.scss';

.card {
  &__container {
    position: relative;
    display: block;
    cursor: pointer;
  }

  &__image-wrapper {
    $skeletonColor: #e6e8eb;
    $gradient: linear-gradient(180deg, #f2f2f2, 0%, $skeletonColor 100%);

    position: relative;
    overflow: hidden;

    width: 100%;
    padding-top: calc(100% * 0.54);
    border-radius: 0.8rem;

    background-image: $gradient;
    background-position: center center;
    background-size: 100%;

    &--placeholder {
      background-image: skeleton-icon(#d3d3d3), $gradient;
      background-position: center calc(50% + 0.8rem), left top;
      background-size: 10.6rem 5.6rem, 100%;
      background-repeat: no-repeat;
    }
  }

  &__image {
    position: absolute;
    top: 50%;
    left: 50%;
    display: inline-block;
    width: 106%;
    max-width: none;

    transform: translate(-50%, -50%);
  }

  &__badge {
    position: absolute;
    top: 0.8rem;
    left: 0.8rem;
    z-index: 1;
    width: 6rem;
    height: 2.4rem;
    border-radius: 4rem;
    font-family: aRocket, sans-serif;
    div {
      width: 100%;
      border-radius: 4rem;
      font-size: 1.1rem;
      line-height: 2.4rem;
      text-align: center;
    }
  }

  &__labels {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    height: 2.5rem;
    margin: 1.6rem 0 0.8rem;
    li {
      height: 1.7rem;
      margin-right: 0.8rem;
      padding: 0.4rem 0.8rem;
      border-radius: 0.4rem;
      background: #f2f2f2;
      font-size: 1.1rem;
      color: #6e6e73;
      @include mq($until: 600px) {
        height: 1.6rem;
        padding: 0;
        padding-top: 0;
        background: transparent;
        color: #9b9ba0;
      }
    }

    @include mq($until: 600px) {
      height: 1.6rem;
      margin-top: 0.8rem;
      margin-bottom: 0.4rem;
      background: transparent;
      color: #9b9ba0;
    }
  }

  &__title {
    @include ellipsis(2);
    max-height: 4.8rem;
    font-weight: 500;
    font-size: 1.6rem;
    @include mq($until: 600px) {
      font-size: 1.4rem;
    }
  }

  &__content {
    @include ellipsis(2);
    max-height: 3.6rem;
    margin-top: 0.8rem;
    font-size: 1.2rem;
    color: #9b9ba0;
    @include mq($until: 600px) {
      display: none;
    }
  }
}
</style>
